import script from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccount.vue?vue&type=style&index=0&id=0e485d76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e485d76"]])

export default __exports__